import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ApiService } from './api.service';
import { ApiEndpoints } from '@core/constants/api-endpoints';
import { SubscriptionService } from './subscription.service';

@Injectable({ providedIn: 'root' })
export class FlatService {
  constructor(
    private readonly api: ApiService,
    private readonly subscriptionService: SubscriptionService
  ) {}

  create(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.FLAT_CREATE, payload).pipe(
      tap((res: any) => {
        if (`${res?.code ?? ''}` === '000') {
          this.subscriptionService.requestSummaryRefresh();
        }
      })
    );
  }

  update(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.FLAT_UPDATE, payload);
  }

  list(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.FLAT_LIST, payload);
  }

  delete(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.FLAT_DELETE, payload);
  }
}
